import React, { useState, useEffect, useCallback } from "react";
import { getRotatedImage } from "./rotateImage";
import { Slider, IconButton } from "@material-ui/core";
import UndoIcon from "@material-ui/icons/Undo";
import RedoIcon from "@material-ui/icons/Redo";
import CancelIcon from "@material-ui/icons/Cancel";
import ControlCameraIcon from "@material-ui/icons/ControlCamera";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import getCroppedImg from "./cropImage";
import Cropper from "react-easy-crop";
import ImgDialog from "./ImgDialog";
import "./styles.css";
import { useSelector, useDispatch } from "react-redux";
import { fetchRequest } from "../../redux/actions/fetch/fetchActions";
import DialogOcr from "../DialogOcr/DialogOcr";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import config from "../../config";

const OptimizedDialogOcr = React.memo(DialogOcr);

export default function Crop(props) {
  const { imageDataUrl, handleClose, setTitle, title, load, typeload } = props;
  const [imageConfig, setImageConfig] = useState({
    imageSrc: imageDataUrl,
    crop: { x: 0, y: 0 },
    zoom: 3,
    aspect: { width: 120, height: 50 },
    croppedAreaPixels: null,
    croppedImage: null,
    isCropping: false,
  });

  const [orignalImage, setOriginalImage] = useState(imageDataUrl);

  const [croppedImageTicket, setCroppedImageTicket] = useState(null);
  const [croppedImageTons, setCroppedImageTons] = useState(null);
  const [isTicket, setIsTicket] = useState(true);
  const [imageTicket, setImageTicket] = useState(null);
  const [imageTons, setImageTons] = useState(null);

  const [defaultAspect, SetDefaultAspect] = useState(1);
  const [defaultAngle, SetDefaultAngle] = useState(1);

  const [openDialogCropResult, setOpenDialogCropResult] = useState(false);
  const [ocrResult, setOcrResult] = useState(null);

  const handleCloseAll = () => {
    resetCrop();
    setCroppedImageTicket(null);
    setCroppedImageTons(null);
    setIsTicket(true);
    setImageTicket(null);
    setImageTons(null);
    setOpenDialogCropResult(false);
    setOcrResult(null);
    handleClose();
  };

  const dispatch = useDispatch();
  const fetch = useSelector((state) => state.fetch);

  const handleCloseDialogCropResult = useCallback(() => {
    setOpenDialogCropResult(false);
  }, []);

  const resetCrop = () => {
    SetDefaultAspect(1);
    SetDefaultAngle(1);
    setImageConfig({
      ...imageConfig,
      crop: { x: 0, y: 0 },
      zoom: 3,
      aspect: { width: 120, height: 50 },
      croppedAreaPixels: null,
      croppedImage: null,
      isCropping: false,
    });
  };

  useEffect(() => {
    if (imageDataUrl) {
      setImageConfig({
        ...imageConfig,
        imageSrc: imageDataUrl,
      });

      setOriginalImage(imageDataUrl);
    }
  }, [imageDataUrl]);

  useEffect(() => {
    if (fetch.response != null) {
      setOpenDialogCropResult(true);
      setOcrResult(fetch.response.result);
    }
  }, [fetch.response]);


  useEffect(() => {
    if (croppedImageTons && croppedImageTicket) {
      let formData = new FormData();
      const jsonticket = croppedImageTicket;
      const jsontons = croppedImageTons;
      formData.append("tripId", load.id);
      formData.append("type", typeload === 1 ? "PICKUP" : "DELIVERY");
      formData.append("image", imageConfig.imageSrc);
      formData.append("ticket", JSON.stringify(jsonticket));
      formData.append("tons", JSON.stringify(jsontons));

      const authKey = localStorage.getItem("key");

      const url = `${config.API_URL}services/app/Trip/GetTicketOcr?key=${authKey}`
      const token = localStorage.getItem("token");
      const options = {
        headers: {
          'Content-Type': 'multipart/form-data',
          accept: 'application/json',
          Authorization: `Bearer ${token}`,
          "Abp.Tenantid": config.TENANT_ID
        }
      }

      dispatch(
        fetchRequest(
          url,
          formData,
          options,
          "POST",
          false
        )
      );
    }
  }, [croppedImageTicket, croppedImageTons]);

  useEffect(() => {
    if (isTicket) {
      setTitle("Ticket #");
    } else {
      setTitle("Tons");
    }
  }, [isTicket]);

  const aspectDefault = {
    "1": { width: 120, height: 50 },
    "2": { width: 190, height: 50 },
    "3": { width: 230, height: 50 },
    "4": { width: 290, height: 100 },
  };

  const ORIENTATION_TO_ANGLE_IMAGE = {
    "1": 0,
    "2": 90,
    "3": 180,
    "4": -90,
  };

  const onCropChange = (crop) => {
    setImageConfig({
      ...imageConfig,
      crop: crop,
    });
  };

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setImageConfig({
      ...imageConfig,
      croppedAreaPixels: croppedAreaPixels,
    });
  };

  const onZoomChange = (zoom) => {
    if (zoom === 1) {
      setImageConfig({
        ...imageConfig,
        zoom: zoom,
        crop: { x: 0, y: 0 },
      });
    } else {
      setImageConfig({
        ...imageConfig,
        zoom: zoom,
      });
    }
  };

  const changeAspect = () => {
    const aspect = aspectDefault[defaultAspect + 1];

    if (aspect) {
      setImageConfig({
        ...imageConfig,
        aspect: aspect,
      });
      SetDefaultAspect(defaultAspect + 1);
    } else {
      SetDefaultAspect(1);
      setImageConfig({
        ...imageConfig,
        aspect: aspectDefault[1],
      });
    }
  };

  const ChangeAngleRedo = async () => {
    const angle = ORIENTATION_TO_ANGLE_IMAGE[defaultAngle + 1];

    if (angle) {
      const imageDataUrl = await getRotatedImage(
        orignalImage,
        angle
      ).catch((err) => console.log(err));
      setImageConfig({
        ...imageConfig,
        imageSrc: imageDataUrl,
      });
      SetDefaultAngle(defaultAngle + 1);
    } else {
      setImageConfig({
        ...imageConfig,
        imageSrc: orignalImage,
      });
      SetDefaultAngle(1);
    }
  };

  const ChangeAngleUndo = async () => {
    const angle = ORIENTATION_TO_ANGLE_IMAGE[defaultAngle - 1];
    let angleNumber = defaultAngle - 1;

    if (angleNumber === 1) {
      setImageConfig({
        ...imageConfig,
        imageSrc: orignalImage,
      });
      SetDefaultAngle(1);
    } else {
      if (angle) {
        const imageDataUrl = await getRotatedImage(
          orignalImage,
          angle
        ).catch((err) => console.log(err));
        setImageConfig({
          ...imageConfig,
          imageSrc: imageDataUrl,
        });
        SetDefaultAngle(defaultAngle - 1);
      } else {
        const imageDataUrl = await getRotatedImage(
          orignalImage,
          -90
        ).catch((err) => console.log(err));
        setImageConfig({
          ...imageConfig,
          imageSrc: imageDataUrl,
        });
        SetDefaultAngle(4);
      }
    }
  };

  const showResult = async () => {
    try {
      setImageConfig({
        ...imageConfig,
        isCropping: true,
      });

      const croppedImage = await getCroppedImg(
        imageConfig.imageSrc,
        imageConfig.croppedAreaPixels
      );


      setImageConfig({
        ...imageConfig,
        croppedImage: croppedImage.blob,
        isCropping: false,
      });
    } catch (e) {
      setImageConfig({
        ...imageConfig,
        isCropping: false,
      });
      console.error(e);
    }
  };

  function blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  const onClose = async () => {
    setImageConfig({
      ...imageConfig,
      croppedImage: null,
    });
  };

  return (
    <div className='App'>
      {imageDataUrl && (
        <>
          <div className='button'>
            <IconButton
              aria-label='delete'
              style={{ color: "green" }}
              onClick={showResult}
              disabled={imageConfig.isCropping}
            >
              <CheckCircleIcon fontSize='large' />
            </IconButton>
            <IconButton
              aria-label='delete'
              color='primary'
              onClick={changeAspect}
            >
              <ControlCameraIcon fontSize='large' />
            </IconButton>
            <IconButton
              aria-label='delete'
              color='primary'
              onClick={ChangeAngleUndo}
            >
              <UndoIcon fontSize='large' />
            </IconButton>
            <IconButton
              aria-label='delete'
              color='primary'
              onClick={ChangeAngleRedo}
            >
              <RedoIcon fontSize='large' />
            </IconButton>
            <IconButton
              aria-label='delete'
              style={{ color: "red" }}
              onClick={handleClose}
            >
              <CancelIcon fontSize='large' />
            </IconButton>
          </div>
          <div className='crop-container'>
            <Cropper
              image={imageConfig.imageSrc}
              crop={imageConfig.crop}
              zoom={imageConfig.zoom}
              aspect={16 / 9}
              onCropChange={onCropChange}
              onCropComplete={onCropComplete}
              onZoomChange={onZoomChange}
              maxZoom={10}
              showGrid={false}
              restrictPosition={true}
              cropSize={imageConfig.aspect}
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <div className='controls'>
            <Slider
              value={imageConfig.zoom}
              min={1}
              max={10}
              step={0.1}
              aria-labelledby='Zoom'
              onChange={(e, zoom) => onZoomChange(zoom)}
            />
          </div>

          <ImgDialog
            img={imageConfig.croppedImage}
            onClose={onClose}
            title={title}
            resetCrop={resetCrop}
            setIsTicket={setIsTicket}
            isTicket={isTicket}
            setCroppedImageTicket={setCroppedImageTicket}
            setCroppedImageTons={setCroppedImageTons}
            croppedAreaPixels={imageConfig.croppedAreaPixels}
            setImageTicket={setImageTicket}
            setImageTons={setImageTons}
          />
          <OptimizedDialogOcr
            isOpen={openDialogCropResult}
            handleClose={handleCloseDialogCropResult}
            handleCloseAll={handleCloseAll}
            data={ocrResult}
            urlTicket={imageTicket}
            urlTons={imageTons}
            typeload={typeload}
            load={load}
            jsonticket={croppedImageTicket}
            jsontons={croppedImageTons}
            image={imageConfig.imageSrc}
          />
          <LoadingSpinner isLoading={fetch.loading} />
        </>
      )}
    </div>
  );
}
